<template>
  <div class="step-content">
    <span><span class="number-step"># 4 - </span>Accéder à « <strong>Comprendre votre vision</strong> »</span>
    <span class="target">
      <img class="screen-tuto" src="../../assets/tuto/screen-1-step-1.png" />
    </span>
    <span>pour expliquer en vidéos les différents défauts et gênes visuels à votre client.</span>
    <img class="screen-tuto" src="../../assets/tuto/screen-2-step-4.png" />
  </div>
</template>

<script>
export default {
  name: 'Step4',
};
</script>

<style scoped>
.step-content {
  padding: 0 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
}
.screen-tuto {
  width: 300px;
}

.number-step {
  font-weight: bolder;
  font-size: 30px;
  color: #0088ec;
}
.target {
  position: relative;
}
strong {
  font-size: 20px;
  color: black;
}
.target::after {
  content: '';
  display: block;
  width: 85px;
  height: 90px;
  border: 2px dashed #0088ec;
  position: absolute;
  top: 45px;
  right: 42px;
}
</style>
